"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Divider_1 = __importDefault(require("@material-ui/core/Divider"));

var Grid_1 = __importDefault(require("@material-ui/core/Grid"));

var Typography_1 = __importDefault(require("@material-ui/core/Typography"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importStar(require("react"));

var utils_1 = require("../../../utils");

var Section_1 = __importDefault(require("../../Card/Section"));

var FontAwesome_1 = __importDefault(require("../../Icon/FontAwesome"));

require("./style.scss");
/**
* Section for a `SideBar` Component.
*/


var SideBarSection = function SideBarSection(_a) {
  var accentColor = _a.accentColor,
      icon = _a.icon,
      index = _a.index,
      isActive = _a.isActive,
      onClick = _a.onClick,
      style = _a.style,
      text = _a.text,
      textColor = _a.textColor;

  var _b = (0, react_1.useState)(false),
      isHovered = _b[0],
      setIsHovered = _b[1];

  var toggleHover = function toggleHover() {
    return setIsHovered(!isHovered);
  };

  var cardSectionStyle = {
    textAlign: 'center'
  };
  var eventClass = '';

  if (isActive) {
    eventClass = '--active';
    cardSectionStyle.borderColor = accentColor;
    cardSectionStyle.color = accentColor;
    cardSectionStyle.backgroundColor = textColor;
  } else if (isHovered) {
    eventClass = '--hovered';
    cardSectionStyle.background = accentColor;
    cardSectionStyle.borderColor = textColor;
    cardSectionStyle.color = textColor;
  }

  var classes = (0, utils_1.classList)('story-sidebar__section', eventClass);

  var handleClick = function handleClick() {
    return onClick(index);
  };

  return react_1.default.createElement("div", {
    className: classes,
    onClick: handleClick,
    onKeyPress: handleClick,
    onMouseEnter: toggleHover,
    onMouseLeave: toggleHover,
    role: "button",
    style: style,
    tabIndex: 0
  }, react_1.default.createElement(Section_1.default, {
    style: cardSectionStyle
  }, react_1.default.createElement(Grid_1.default, {
    container: true
  }, react_1.default.createElement(Grid_1.default, {
    item: true,
    xs: 3
  }, icon), react_1.default.createElement(Grid_1.default, {
    item: true,
    xs: 1
  }, react_1.default.createElement(Divider_1.default, {
    orientation: "vertical"
  })), react_1.default.createElement(Grid_1.default, {
    className: "story-sidebar-text",
    item: true,
    xs: 8
  }, react_1.default.createElement(Typography_1.default, {
    variant: "subtitle2"
  }, text)))));
};

SideBarSection.propTypes = {
  /** The color to style the `SideBarSection` during events  */
  accentColor: prop_types_1.default.string,

  /** The `SideBar` `Icon` that relates to the `Moment` */
  icon: prop_types_1.default.element,

  /** Way to disambiguate this `SideBarSection` during a callback  */
  index: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]).isRequired,

  /** Determines if the `Moment` is currently rendered on the `Story`  */
  isActive: prop_types_1.default.bool,

  /** Click handler callback used by the `SideBar` */
  onClick: prop_types_1.default.func,

  /** Styling object of the `SideBar` */
  // eslint-disable-next-line react/forbid-prop-types
  style: prop_types_1.default.object,

  /** The `SideBar` label of the `Moment` */
  text: prop_types_1.default.string.isRequired,

  /** The color to style the `SideBarSection` text when active  */
  textColor: prop_types_1.default.string
};
SideBarSection.defaultProps = {
  accentColor: undefined,
  icon: react_1.default.createElement(FontAwesome_1.default, {
    name: "FaInfoCircle"
  }),
  isActive: false,
  onClick: function onClick() {},
  style: {},
  textColor: undefined
};
exports.default = SideBarSection;